import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import Util from "../../../../util/Util";
import { addCollaboratorEstablishment } from "../../../../actions/collaborators/collaborators";
import CollaboratorAssignments from "./CollaboratorAssignments";

class Assignments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      establishment_id: "",

      disabled: false,
    };
  }

  isUpdate() {
    return (
      this.props.collaborator !== undefined && this.props.collaborator !== null
    );
  }

  close() {
    this.props.close();
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  onChange(field, value) {
    this.setState({ [field]: value });
  }

  addEstablishment() {
    if (Util.emptyString(this.state.establishment_id) || this.state.disabled)
      return;

    var data = {
      collaboratorId: this.props.collaborator._id,
      establishmentId: this.state.establishment_id,
    };

    this.setState({ disabled: true });

    var successCallback = () => {
      this.setState({ disabled: false });
    };

    this.props.onAddCollaboratorEstablishment(data, successCallback);
  }

  render() {
    if (!this.props.collaborator) return null;

    var establishmentsNode = this.props.establishments.map((establishment) => {
      var disabled = false;

      // Remove establishments if already assigned to someone
      for (let collaborator of this.props.collaborators) {
        if (
          collaborator.establishments &&
          collaborator._id === this.props.collaborator._id
        ) {
          for (let e of collaborator.establishments) {
            if (establishment._id === e.establishment_id) {
              disabled = true;
              break;
            }
          }
        }
      }

      return (
        <option
          value={establishment._id}
          key={establishment._id}
          disabled={disabled}
        >
          {establishment.name}
        </option>
      );
    });

    return (
      <React.Fragment>
        <div className="col-12 col-lg-9 col-xl-8">
          <div className="form-group row">
            <label
              htmlFor="establishment_id"
              className="col-12 col-md-5 col-form-label"
            >
              <FormattedMessage id="Assign.Establishment" />
            </label>
            <div className="col-11 col-md-6">
              <select
                className="form-control d-inline"
                id="establishment_id"
                defaultValue={this.state.establishment_id}
                onChange={(e) =>
                  this.onChange("establishment_id", e.target.value)
                }
              >
                <option value=""></option>
                {establishmentsNode}
              </select>
            </div>

            <div className="col-1 text-left align-left float-left p-0">
              <i
                className="fa fa-plus-square icon-huge hoverable clickable d-inline"
                onClick={() => this.addEstablishment()}
                disabled={
                  Util.emptyString(this.state.establishment_id) ||
                  this.state.disabled
                }
              />
            </div>
          </div>
        </div>

        <CollaboratorAssignments collaborator={this.props.collaborator} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    collaborators: state.collaborators,
    establishments: state.establishments,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAddCollaboratorEstablishment: (data, successCallback) =>
      dispatch(addCollaboratorEstablishment(data, successCallback)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Assignments);
